/**
 * @file コンポーネント：パスワード変更モーダル ロジック管理
 */

// ライブラリ読み込み
import React, { useRef, useState } from "react";

// 関数読み込み
import { fnGetParameter } from "~/src/functions/common";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ModalNewPassword = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    /**
     * パスワードを更新ボタンクリック時の処理
     */
    const refConfirmNewPassword = useRef(null); // 新しいパスワード（確認用）
    const refNewPassword = useRef(null); // 新しいパスワード
    const [passwordErrorMessages, setPasswordErrorMessages] = useState([]); // パスワードエラーメッセージ
    const fnClickRecoverPassword = (e) => {
        e.preventDefault();
        const confirmNewPassword = window.btoa(
            refConfirmNewPassword.current.value
        );
        const newPassword = window.btoa(refNewPassword.current.value);
        const api = "/api/users/password";
        const token = document
            .getElementById("requestverificationtoken")
            .getAttribute("value");
        const options = {
            body: JSON.stringify({
                confirmPassword: confirmNewPassword,
                email: props.email,
                oldPassword: props.oldPassword,
                password: newPassword,
            }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: token,
            },
            method: "PUT",
        };
        fetch(api, options)
            .then((response) => {
                // エラーページにリダイレクトされた場合
                if (response.url.indexOf("Error") !== -1) {
                    throw new Error("An error has occurred.");
                }
                // ステータスコードが200番台以外かつ400番以外の場合
                if (!response.ok && response.status !== 400) {
                    throw new Error(String(response.status));
                }
                // エラーではない場合
                return response;
            })
            .then((response) => response.json())
            .then((result) => {
                if (result.StatusCode === 200) {
                    // ログイン処理
                    const loginApi = "/api/login";
                    const loginOptions = {
                        body: JSON.stringify({
                            email: props.email,
                            password: newPassword,
                            rememberMe: false,
                        }),
                        headers: {
                            "Content-Type": "application/json",
                            RequestVerificationToken: token,
                        },
                        method: "POST",
                    };
                    fetch(loginApi, loginOptions)
                        .then((response) => {
                            // エラーページにリダイレクトされた場合
                            if (response.url.indexOf("Error") !== -1) {
                                throw new Error("An error has occurred.");
                            }
                            // ステータスコードが200番台以外かつ400番以外の場合
                            if (!response.ok && response.status !== 400) {
                                throw new Error(String(response.status));
                            }
                            // エラーではない場合
                            return response;
                        })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.StatusCode === 200) {
                                if (
                                    result.UserType === 5 &&
                                    !fnGetParameter("refPage")
                                ) {
                                    // 執刀医権限ユーザーかつrefPageパラメーターがない場合
                                    location.href = "/admin";
                                } else {
                                    location.href = props.redirectUrl;
                                }
                            } else if (result.StatusCode === 400) {
                                const messages = [];
                                for (const error of result.Errors) {
                                    messages.push(error.Message);
                                }
                                props.setLoginErrorMessages(messages);
                                props.setIsOpenModalLogin(true);
                                props.setIsOpenModalNewPassword(false);
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            props.setLoginErrorMessages([
                                localized["ErrorMessage.LoginError"],
                            ]);
                            props.setIsOpenModalLogin(true);
                            props.setIsOpenModalNewPassword(false);
                        });
                } else if (result.StatusCode === 400) {
                    const messages = [];
                    for (const error of result.Errors) {
                        messages.push(error.Message);
                    }
                    setPasswordErrorMessages(messages);
                }
            })
            .catch((error) => {
                console.error(error);
                setPasswordErrorMessages([
                    localized["ErrorMessage.LoginError"],
                ]);
            });
    };
    const fnPressEnter = (e) => {
        if (e.key === "Enter") {
            fnClickRecoverPassword(e);
        }
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            errorMessages={passwordErrorMessages}
            fnClickRecoverPassword={fnClickRecoverPassword}
            fnPressEnter={fnPressEnter}
            refConfirmNewPassword={refConfirmNewPassword}
            refNewPassword={refNewPassword}
        />
    );
};
